import { useQuery } from "@tanstack/react-query";

import { FETCH_ERROR } from "../consts/fetch-error";
import { getHolding, getHoldings } from "../services/holding";

export function useGetHoldings() {
  return useQuery({
    queryKey: ["holdings"],
    queryFn: () => getHoldings(),
    staleTime: 1000 * 60 * 60, // 1 hour
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}

export function useGetHolding(id: string) {
  return useQuery({
    queryKey: ["holding", id],
    queryFn: () => getHolding(id),
    retry: (_failureCount, error: unknown) =>
      error !== FETCH_ERROR.UNAUTHORIZED,
  });
}
